<div *ngIf="activity?.associations?.length > 0">
  <hr class="association-divider" />
  <div class="row">
    <a [glxyPopover]="associations" (click)="openPopover(activity)" class="associations-popup-link">
      <mat-icon class="associations-icon">link</mat-icon>
      <span>
        {{ activity?.associations?.length }}
        {{ (activity?.associations?.length === 1 ? 'ACTIVITY.ASSOCIATION' : 'ACTIVITY.ASSOCIATIONS') | translate }}
      </span>
    </a>
  </div>
</div>
<glxy-popover
  #associations
  [(isOpen)]="popupOpen[activity.crmObjectId]"
  [closeOnBackdropClick]="true"
  [closeOnEscapeKey]="true"
  [positions]="[PopoverPositions.Bottom, PopoverPositions.Top]"
  [maxHeight]="400"
>
  <div *ngIf="contacts()?.length > 0" class="association">
    <div class="subtitle">{{ 'ACTIVITY.POPOVER.CONTACTS' | translate }}</div>
    <div *ngFor="let contact of contacts()">
      <a [routerLink]="routePrefix() + '/' + contact.linkUrl">
        {{ contact.name }}
      </a>
    </div>
  </div>
  <div *ngIf="companies()?.length > 0" class="association">
    <div class="subtitle">{{ 'ACTIVITY.POPOVER.COMPANIES' | translate }}</div>
    <div *ngFor="let company of companies()">
      <a [routerLink]="routePrefix() + '/' + company.linkUrl">
        {{ company.name }}
      </a>
    </div>
  </div>
  <div *ngIf="opportunities()?.length > 0" class="association">
    <div class="subtitle">{{ 'ACTIVITY.POPOVER.OPPORTUNITIES' | translate }}</div>
    <div *ngFor="let opportunity of opportunities()">
      {{ opportunity.name }}
    </div>
  </div>
  <div *ngIf="teamMembers()?.length > 0" class="association">
    <div class="subtitle">{{ 'ACTIVITY.POPOVER.TEAM_MEMBERS' | translate }}</div>
    <div *ngFor="let member of teamMembers()">
      {{ member.name }}
    </div>
  </div>
</glxy-popover>
